$(document).ready(function () {
    // Attach event listeners
    $("#edit-account-edit").on("click", toggleEditAccount);
    $("#edit-account-cancel").on("click", toggleEditAccount);

    // Initial state: Ensure everything is properly hidden on page load
    initializeEditAccountForm();
});

/**
 * Toggles the visibility of the account editing form
 */
function toggleEditAccount() {
    $("#edit-account-edit").toggle(); // Toggle 'Edit Account Information' button
    $("#edit-account-submit").toggle(); // Toggle 'Save Changes' button
    $("#edit-account-cancel").toggle(); // Toggle 'Cancel' button
    $("#edit-account-delete").toggle(); // Toggle 'Delete Account' button

    // Toggle inputs visibility
    $('.inputs-edit-account').each(function () {
        $(this).toggle();

        // Reset field names when made visible
        if ($(this).is(':visible')) {
            const originalName = $(this).attr('data-original-name');
            if (originalName) {
                $(this).attr('name', originalName);
            }
        } else {
            // Obfuscate name attribute when hidden
            const uniqueDummyName = `dummy_field_${Math.random().toString(36).substring(7)}`;
            $(this).attr('name', uniqueDummyName);
        }
    });
}

/**
 * Initializes the form to the default state (hidden on page load)
 */
function initializeEditAccountForm() {
    $("#edit-account-edit").show(); // Ensure "Edit Account Information" is visible
    $("#edit-account-submit").hide(); // Hide "Save Changes"
    $("#edit-account-cancel").hide(); // Hide "Cancel"
    $("#edit-account-delete").show(); // Leave "Delete Account" visible
    $(".inputs-edit-account").hide(); // Hide all the editable input fields
}
